/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Questions = {
    type: 'array',
    contains: {
        type: 'ResponseQuestion',
    },
};